<template>
    <div>
        <a-card style="width: 100%;">
            <a-row
                :gutter="24"
                type="flex"
                justify="start"
                style="margin-bottom: 16px;"
            >
                <a-col
                    ><a-input
                        placeholder="请搜索任务名称或人员姓名"
                        style="width: 200px;"
                        v-model="params.keywords"
                        @blur="askDatas"
                        allowClear
                        @onSearch="askDatas"
                        @keyup.enter="askDatas"
                /></a-col>
                <a-col>
                    <a-select
                        placeholder="请选择状态"
                        style="width: 200px;"
                        @change="askDataing"
                        v-model="params.status"
                        allowClear
                    >
                        <a-select-option value="1">进行中</a-select-option>
                        <a-select-option value="2">已完成</a-select-option>
                        <a-select-option value="-1">已删除</a-select-option>
                    </a-select>
                </a-col>
                <a-col>
                    <a-select
                        placeholder="请选择部门"
                        style="width: 200px;"
                        @change="askDataing"
                        allowClear
                        v-model="params.departmen_id"
                    >
                        <a-select-opt-group :label="item.name" v-for="item in departmentlist"
                                :key="item.id">
                            <a-select-option
                                v-for="items in item.children"
                                :key="items.id"
                                :value="items.id"
                                >{{ items.name }}</a-select-option
                            >
                        </a-select-opt-group>
                    </a-select>
                </a-col>
                <a-col>
                    <a-range-picker
                        v-model="dateaskDatas"
                        @change="dateaskData"
                    />
                </a-col>
            </a-row>
            <a-table
                :columns="columns"
                :dataSource="data"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                @change="handleTableChange"
            >
                <span slot="status" slot-scope="text, record">
                    <a-tag color="red" v-if="+record.status === 1"
                        >进行中</a-tag
                    >
                    <a-tag color="red" v-else-if="+record.status === 2"
                        >已完成</a-tag
                    >
                    <a-tag color="red" v-else>已删除</a-tag>
                </span>
            </a-table>
        </a-card>
    </div>
</template>

<script>
import { gettodoindex, departmentindex } from "@/api/manage";

// table表格数据配置
export default {
    data() {
        return {
            loading: false,
            departmentlist: [],
            params: {
                keywords: "",
                status: undefined,
                departmen_id: undefined,
                start_time: "",
                end_time: "",
            },
            dateaskDatas: [],
            pagination: { total: 0, pageSize: 10, current: 1 },
            data: [],
            columns: [
                {
                    title: "任务名称",
                    dataIndex: "task",
                    ellipsis: true,
                    width: "100",
                },
                {
                    title: "状态",
                    scopedSlots: { customRender: "status" },
                    width: "8%",
                },
                {
                    title: "创建人",
                    dataIndex: "user",
                    width: "8%",
                },
                {
                    title: "所属部门",
                    dataIndex: "name",
                    width: "8%",
                },
                {
                    title: "创建时间",
                    dataIndex: "create_time",
                    width: "15%",
                },
            ],
        };
    },
    mounted() {
        this.initial();
    },
    methods: {
        initial() {
            this.askData();
            this.department();
        },
        askData() {
            let params = {
                page: this.pagination.current,
                pageSize: this.pagination.pageSize,
                keywords: this.params.keywords ? this.params.keywords : "",
                status: this.params.status ? this.params.status : "",
                departmen_id: this.params.departmen_id
                    ? this.params.departmen_id
                    : "",
                start_time: this.params.start_time,
                end_time: this.params.end_time,
            };
            return gettodoindex(params).then((res) => {
                this.data = res.result.list;
                this.pagination.total = res.result.total;
                // console.log(this.pagination);
            });
        },
        askDatas() {
            this.pagination.current = 1
            this.params.status = undefined;
            this.params.departmen_id = undefined;
            this.params.start_time = "";
            this.params.end_time = "";
            this.askData();
        },
        dateaskData(e, es) {
            this.pagination.current = 1
            this.params.start_time = es[0];
            this.params.end_time = es[1];
            this.askData();
        },
        askDataing() {
            this.pagination.current = 1
            this.askData();
        },
        handleTableChange(pagination) {
            this.pagination = pagination;
            this.askData();
        },
        department() {
            return departmentindex().then((res) => {
                this.departmentlist = res.result
            });
        },
    },
};
</script>
